import React from 'react';
import { Card, CardHeader, CardTitle, CardContent, CardDescription } from "@/components/ui/card";
import { MessageSquare, Info } from 'lucide-react';

export const RecentDiscussionsWidget = () => {

  return (
      <Card className="border-gray-100">
      <CardHeader className="pb-2">
        <div className="flex items-center gap-2">
          <MessageSquare className="h-5 w-5 text-gray-500" />
          <CardTitle className="text-lg text-gray-700">Recent Compliance Discussions</CardTitle>
        </div>
        <CardDescription className="text-gray-500 flex items-center gap-1">
          <Info className="h-3.5 w-3.5 text-gray-400" />
          <span>Compliance-related chat history</span>
        </CardDescription>
      </CardHeader>
      <CardContent className="flex flex-col items-center justify-center h-[200px] text-center">
        <MessageSquare className="h-10 w-10 text-gray-300" />
        <p className="mt-4 text-sm text-gray-500">Coming soon: Recent Compliance Discussions</p>
      </CardContent>
    </Card>
  );
};
